import React from 'react';

import { tabsMessages } from '../../../../translates/tabsMessages';
import { useContentWrapperContext } from '../../ContentWrapper/ContentWrapper';
import { TabsListing } from '../TabsListing/TabsListing';
import { HotspotTab } from '@ael/core-api';
import { useClickOut } from '@ael/shared-components-library';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import * as Immutable from 'immutable';
import { FormattedMessage } from 'react-intl';

import './ShowAll.scss';

interface ShowAllProps {
  tabs: Immutable.List<HotspotTab>;
  selectedTabIndex: number;
  onTabSelected: (index: number) => void;
}

export const ShowAll: React.FC<ShowAllProps> = ({ tabs, onTabSelected, selectedTabIndex }) => {
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const { isOpen: showAllSelected, setIsOpen: setShowAllSelected } = useClickOut(false, wrapperRef);
  const { toggleControls, isControlVisible } = useContentWrapperContext();

  const toggleShowAll = () => {
    setShowAllSelected((old) => !old);
  };

  React.useEffect(() => {
    if (showAllSelected) {
      toggleControls(true);
    }
  }, [showAllSelected, toggleControls]);

  React.useEffect(() => {
    if (!isControlVisible) {
      setShowAllSelected(false);
    }
  }, [isControlVisible, setShowAllSelected]);

  const selectTab = (index: number) => {
    setShowAllSelected(false);
    onTabSelected(index);
  };

  const showControl = () => {
    toggleControls(true);
  };

  return (
    <div
      ref={wrapperRef}
      className={classNames('tabs-bar__show-all', {
        'tabs-bar__show-all--active': showAllSelected,
      })}
      onClick={toggleShowAll}
      onMouseEnter={showControl}
    >
      <span className="tabs-bar__show-all__label">
        <FormattedMessage {...tabsMessages.showAll} />
      </span>
      <FontAwesomeIcon
        icon={solid('chevron-right')}
        rotation={showAllSelected ? 90 : undefined}
        className="tabs-bar__show-all__icon"
      />

      <TabsListing tabs={tabs} onSelect={selectTab} selectedTabIndex={selectedTabIndex} show={showAllSelected} />
    </div>
  );
};
